import { Box } from '@mui/material';
import { styled } from '@mui/system';

interface ItemWrapperStyledType {
  $isHover: boolean;
}

export const BodyStyled = styled(Box)(({ theme }) => ({
  width: '316px',
  borderRadius: '0 0 12px 12px',
  display: 'flex',
  justifyContent: 'end',
  flexDirection: 'column',
  padding: '12px',
  gap: '8px',
}));

export const ItemWrapperStyled = styled(Box)<ItemWrapperStyledType>(
  ({ theme, $isHover }) => ({
    position: 'relative',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '12px',
    borderRadius: '8px',
    background: theme.palette['grey']['100'],
    border: `2px solid ${
      $isHover ? theme.palette['orange']['50'] : 'transparent'
    }`,
  }),
);
